/* eslint-disable @typescript-eslint/no-unused-vars */
export const audienceAdgroupStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, { creationContainerMarginLeft = 32 } = {}) => ({

  '& .audience-adgroup-creation-wizard-container, & .audience-adgroup-settings-wizard-container': {
    '& .cashback-percent-container': {
      display: 'flex',
      '& select': {
        width: 180,
        marginRight: 10,
      },
      '& .cashback-inherit-container, & .cashback-input-container': {
        display: 'flex',
        '& .cashback-percent-input': {
          width: 90,
        },
        '& .input-group-addon': {
          width: 'auto',
          paddingTop: 8,
        },
      },
    },

    '& h1': {
      borderBottom: '1px solid rgb(237, 235, 233)',
      margin: 0,
      fontSize: 20,
      paddingTop: 20,
      paddingBottom: 20,
      paddingLeft: 16,
    },

    '& .adgroup-creation-step1-container': {
      marginLeft: creationContainerMarginLeft,

      '& .form-horizontal>.form-group:nth-child(1)>.control-label:nth-child(1)': {
        marginTop: 0,
        '&.crud-adgroup-schedule-label': {
          marginTop: 33,
        },
      },

      '& .name-input-control-container': {
        '& .Name-value': {
          width: 438,
        },
      },

      '& .remaining-chars-hint-container': {
        width: 438,

        '& .remaining-chars-hint': {
          margin: 0,
        },
      },

      '& .bidding-strategy-container': {
        '& select': {
          width: 438,
        },

        '& #BidStrategySetting_BidStrategy_Label': {
          padding: [5, 0],
        },

        '& .col-sm-6 > .form-control-static': {
          minHeight: 1,
          paddingBottom: 8,
        },
      },

      '& .default-bid-container': {
        width: 438,

        '& .input-group-addon': {
          background: palette.white,
          border: 0,
          color: palette.neutralPrimary,
          padding: '6px 6px 6px 12px',
        },
      },

      '& .audience-advanced-settings-section': {
        marginTop: 30,

        '& .audience-advanced-settings-header': {
          marginLeft: 0,
          padding: 0,
          fontSize: 18,
          '& .expanderImage, .expandedImage': {
            fontSize: 18,
            marginRight: 11,
          },
        },

        '& .audience-advanced-settings': {
          marginLeft: creationContainerMarginLeft,

          '& .ad-schedule': {
            marginLeft: 16,
          },
        },

      },
    },

    '& .audience-adgroup-creation-wizard-step2': {
      '& .crud-audience-target-selector': {
        paddingTop: 0,
      },
    },
  },

  '& .audience-adgroup-settings-wizard-container': {
    overflow: 'auto',
  },
});
